import type { UnitInfoDataInterface } from 'store/unitInfoData/types';
import { UnitTypes } from 'unitData/types';

export const getUnitInfoData = (
  unitType: UnitTypes,
  unitInfoData: UnitInfoDataInterface,
) => {
  switch (unitType) {
    case UnitTypes.FEED:
    case UnitTypes.HYBRID_CRUSHER_CR:
    case UnitTypes.PAN_FEEDER_SP:
    case UnitTypes.GRIZZLY_SCREEN:
    case UnitTypes.SCHENCK_SCREEN:
    case UnitTypes.KWATANI_SCREEN:
    case UnitTypes.FEEDER_AND_SCREEN:
    case UnitTypes.PLATE_FEEDER_SH:
    case UnitTypes.GRIZZLY_FEEDER_GENERAL:
    case UnitTypes.MOBILE_JAW_AND_CONE:
    case UnitTypes.MOBILE_VSI:
    case UnitTypes.IMPACT_CRUSHER_CI:
    case UnitTypes.IMPACT_CRUSHER_CV:
      return unitInfoData[unitType];
    case UnitTypes.GRIZZLY_FEEDER_SV:
      return unitInfoData[UnitTypes.GRIZZLY_FEEDER_GENERAL];
    case UnitTypes.MOBILE_TRACKED_HSI:
    case UnitTypes.MOBILE_WHEELED_HSI:
      return unitInfoData[UnitTypes.MOBILE_HSI_COMMON];
    case UnitTypes.MOBILE_WHEELED_CONE:
    case UnitTypes.MOBILE_TRACKED_CONE:
      return unitInfoData[UnitTypes.MOBILE_CONE_COMMON];
    case UnitTypes.MOBILE_WHEELED_SCREEN:
    case UnitTypes.MOBILE_TRACKED_SCREEN:
      return unitInfoData[UnitTypes.MOBILE_SCREEN_COMMON];
    case UnitTypes.MOBILE_WHEELED_JAW:
    case UnitTypes.MOBILE_TRACKED_JAW:
      return unitInfoData[UnitTypes.MOBILE_JAW_COMMON];
    case UnitTypes.STORAGE_FEEDER:
    case UnitTypes.STORAGE_FEEDER_2_OUTPUTS:
      return unitInfoData[UnitTypes.PAN_FEEDER_SP];
    case UnitTypes.CONE_CRUSHER_CH:
      return unitInfoData[UnitTypes.CONE_CRUSHER_CH];
    default:
      return {};
  }
};
